export const filterId = 'capitalize';
export const factory = () =>
    input => ((!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '');